// src/App.js

import React from 'react';
import AppProvider from './components/AppProvider';

function App() {
  return <AppProvider />;
}

export default App;